import { render, staticRenderFns } from "./StepHeader.vue?vue&type=template&id=625a5898"
import script from "./StepHeader.vue?vue&type=script&lang=js"
export * from "./StepHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports